import { IReview, defaultReview } from '@ugc-components/ugc-pdp-review/interface';

export interface ISwitchLanguage {
  isShowOriginalLanguage: boolean;
  reviewTitle: string;
  reviewText: string;
}

interface ISwitchLanguageState {
  isShowSwitchLanguageModal: boolean;
  switchLanguage: { [key: string]: ISwitchLanguage };
  switchLanguageModal: {
    reviewItem: IReview;
    isModal: boolean;
  };
}

const switchLanguage: ISwitchLanguageState = {
  isShowSwitchLanguageModal: false,
  switchLanguage: {},
  switchLanguageModal: {
    reviewItem: defaultReview,
    isModal: false,
  },
};

export default switchLanguage;
